<template>
  <div>
    <div v-for="(item, index) in data" :key="index">
      <el-checkbox :label="item.id" v-model="selectedItems" @change="handleChange">
        <span>{{ item.name }}</span>
      </el-checkbox>
      <a v-if="item.preview_url" :href="item.preview_url" target="_blank" style="margin-left: 10px"><i class="material-icons md-24" style="color: #9EACB7">&#xe8f4;</i></a>
    </div>
  </div>
</template>

<script>
    export default {
        name: "LandingSelect",
        props: {
            value: [String, Number, Array],
            data: [Array]
        },
        data () {
            return {
                selectedItems: this.value || []
            }
        },
        watch:{
            'value'(){
                this.selectedItems = this.value
            },
        },
        methods: {
            handleChange () {
                this.$emit('input', this.selectedItems);
            }
        }
    }
</script>

<style scoped>

</style>